var React = require('react');

function TextIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.75405 1.75405H9.17262V18.246H6.21574V20H13.8835V18.246H10.9267V1.75405H18.3452V5.36124H20.0993V0H0V5.36124H1.75405V1.75405Z","fill":"#836CF2","key":0}),React.createElement("path",{"d":"M15.0524 9.05243H19.5036V18.9476H17.7294V20H22.3301V18.9476H20.556V9.05243H25.0071V11.2167H26.0596V8H14V11.2167H15.0524V9.05243Z","fill":"#836CF2","key":1})]);
}

TextIcon.defaultProps = {"width":"27","height":"20","viewBox":"0 0 27 20","fill":"none"};

module.exports = TextIcon;

TextIcon.default = TextIcon;
